module.exports = __webpack_public_path__ + "img/ico-close.b6be6133.svg";